import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import store from './store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { account } from '@redux/account';
import i18next from 'i18next';

const accessToken = localStorage.getItem('accessToken');
let language = localStorage.getItem('language');
language = isEmpty(language) ? 'en' : language;
store.dispatch(account.actions.setLanguage(language));
i18next.changeLanguage(language);
if(accessToken) {
  store.dispatch(account.actions.setAccessToken(accessToken));
}

const container = document.getElementById('root');
const root = createRoot(container);

Bugsnag.start({
  releaseStage: 'production',
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  enabledReleaseStages: ['production'],
  plugins: [new BugsnagPluginReact()],
  onError: (event) => {
    const firstError = event.errors?.[0];
    if (!firstError) return;

    const stacktrace = firstError.stacktrace || [];

    // Ignore errors with no useful stack trace (injected by browser extensions, privacy tools, etc.)
    const hasNoStack = stacktrace.length === 0;
    const hasOnlyUnknownFrames = stacktrace.length > 0 && stacktrace.every(
      frame => frame.file === 'unknown file' || !frame.file
    );
    if (hasNoStack || hasOnlyUnknownFrames) return false;

    // Ignore errors where no frame originates from our code
    const hasInProjectFrame = stacktrace.some(frame => frame.inProject);
    if (stacktrace.length > 0 && !hasInProjectFrame) return false;
  },
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <Provider store={store}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <App />
        </React.Suspense>
      </Provider>
    </React.StrictMode>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
